export const googleApiKey = "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
export const facebookPixelId = "7315805455146285"
export const ga4MeasurementId = "G-5TJD2KXG1G"  // Replace with your GA Measurement ID
